import { Button as AntButton, ButtonProps } from 'antd'
import React, { useMemo } from 'react'

import { CheckCircleFilledIcon, CircleIcon } from '../../icons'
import theme from '../../theme'
import { ButtonContainer } from './styles'

export enum NavButtonState {
  EMPTY = 'empty',
  PREFILLED = 'prefilled',
  COMPLETED = 'completed',
}

export interface CustomButtonProps extends ButtonProps {
  isSelected: boolean
  label: string
  onClick: () => void
  state: NavButtonState
}

const NavButton = ({ isSelected, label, onClick, state, ...rest }: CustomButtonProps) => {
  const icon = useMemo(() => {
    switch (state) {
      // TODO: render icons according to state
      case NavButtonState.EMPTY:
        return <CircleIcon />
      case NavButtonState.PREFILLED:
        return <CheckCircleFilledIcon />
      case NavButtonState.COMPLETED:
        return <CheckCircleFilledIcon style={{ color: theme.colors.green6 }} />
    }
  }, [state])

  return (
    <ButtonContainer id="nova-shared-Nav-Button-root" isSelected={isSelected}>
      <AntButton id="nova-shared-Nav-Button-button" onClick={onClick} icon={icon} {...rest}>
        {label}
      </AntButton>
    </ButtonContainer>
  )
}

export default NavButton
